import { useContext, useLayoutEffect } from 'react'
import { createPortal } from 'react-dom'
import { modalContext } from 'providers/modal'

import Login from './Login'
import Welcome from './Welcome'
import Recovery from './Recovery'
import Register from './Register'
import Validate from './Validate'
import Onboarding from './Onboarding'
import DownloadApp from './DownloadApp'


export const MODAL_VARIANTS = {
  welcome: Welcome,
  login: Login,
  recovery: Recovery,
  register: Register,
  validate: Validate,
  onboarding: Onboarding,
  downloadApp: DownloadApp,
}


const Modal = () => {

  const root = document.getElementById('modal')
  const { data } = useContext(modalContext)

  const EmptyComponent = () => {}
  
  const Content = MODAL_VARIANTS[data.variant] || EmptyComponent

  const ModalComponent = (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '999',
        backgroundColor: 'rgba(0,0,0, .3)',
        display: 'grid',
        placeItems: 'center'
      }}
    >
      <Content {...data.props} />
    </div>
  )

  useLayoutEffect(() => {
    if (data.variant) document.body.style.overflow = 'hidden'
    return () => document.body.style.overflow = 'visible'
  }, [data.variant])

  return createPortal( data.variant ? ModalComponent : null, root)
}

export default Modal